import { Link } from "react-router-dom";
import { allMovies } from "@/utils/movie";
import { useFavorites } from "@/hooks/useFavorites";

export default function FavoritesPanel() {
  const { favorites } = useFavorites();
  const items = allMovies.filter((m) => favorites.includes(m.id));

  return (
    <section className="mt-10 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <h2 className="mb-4 flex items-center gap-2 text-lg font-bold text-foreground-950">
        <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-100 text-accent-700">
          <i className="ri-heart-3-line"></i>
        </span>
        我的收藏
        <span className="font-label text-sm font-normal text-foreground-500">（本地保存）</span>
      </h2>
      {items.length === 0 ? (
        <p className="rounded-md bg-background-100 px-4 py-6 text-center text-sm text-foreground-600">
          你还没有收藏任何作品。点击上方“收藏”按钮，即可将喜欢的影视保存到这里。
        </p>
      ) : (
        <div className="flex flex-col divide-y divide-background-200">
          {items.map((m) => (
            <Link
              key={m.id}
              to={`/detail/${m.id}`}
              className="group flex cursor-pointer items-center gap-3 py-3"
            >
              <div className="h-16 w-12 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={m.cover}
                  alt={`${m.title} 海报`}
                  title={`${m.title} 收藏`}
                  className="h-full w-full object-top object-cover"
                />
              </div>
              <div className="flex flex-1 flex-col">
                <span className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600">
                  {m.title}
                </span>
                <span className="text-xs text-foreground-600">
                  {m.type === "movie" ? "电影" : "剧集"} · {m.year} · {m.region}
                </span>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500"></i>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}